export default __webpack_public_path__ + "static/media/project2-DJI_0467.2b0c4db7.jpg";